import commissionsLocales from '@/locales/en/humanResources/commissions.locales';
import employeeLocales from '@/locales/en/humanResources/employee.locales';
import payrollLocales from '@/locales/en/humanResources/payroll.locales';

export default {
    ...employeeLocales,
    ...commissionsLocales,
    ...payrollLocales,
};
